function getPlansState(state) {
  return {
    plansInfo: state.plans.plansInfo,
    errorPlans: state.plans.errorPlans,
    loadingPlans: state.plans.loadingPlans
  };
}

export { getPlansState };
